import { render, staticRenderFns } from "./addRoleDialog.vue?vue&type=template&id=010f129e&scoped=true"
import script from "./addRoleDialog.vue?vue&type=script&lang=js"
export * from "./addRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./addRoleDialog.vue?vue&type=style&index=0&id=010f129e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010f129e",
  null
  
)

export default component.exports